import { CSSProperties } from 'react'

import { Flexbox } from './Flexbox'

const BAD_TO_GOOD_MAP = {
  between: 'space-between',
  center: 'center',
  end: 'flex-end',
  start: 'flex-start',
}

const mapBadToGood = (bad?: Props['alignItems'] | Props['justifyContent']) => {
  if (!bad) return undefined
  return BAD_TO_GOOD_MAP[bad]
}

type Props = {
  className?: string
  alignItems?: 'between' | 'center' | 'end' | 'start'
  flexDirection?: 'column' | 'row'
  justifyContent?: 'between' | 'center' | 'end' | 'start'
  children?: React.ReactNode
  style?: CSSProperties
}

/**
 * @deprecated use `Flexbox` instead!
 * WHY DOES THIS EXIST I can hear you ask? The answer, as always is legacy and laziness.
 * This component existed long before the `<Flexbox />` component and relied on a bunch
 * of styles that have since been removed. This is now just a mapper component to the new way.
 * @param props
 * @returns
 */
const Flex: React.FC<Props> = (props) => {
  const {
    children,
    className,
    alignItems,
    justifyContent,
    flexDirection = 'row',
    style,
  } = props

  return (
    <Flexbox
      justifyContent={mapBadToGood(justifyContent)}
      alignItems={mapBadToGood(alignItems)}
      flexDirection={flexDirection}
      className={className}
      style={style}
    >
      {children}
    </Flexbox>
  )
}

export default Flex
